import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"rice"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 11H21V12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12V11Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M20 11L4 11C4 9.99104 4.18678 8.712 4.52766 7.45268C5.38744 4.2763 8.70931 3 12 3C15.2933 3 18.6138 4.27771 19.4735 7.45682C19.8136 8.7148 20 9.99214 20 11Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M20 11L4 11C4 9.99104 4.18678 8.712 4.52766 7.45268C5.38744 4.2763 8.70931 3 12 3C15.2933 3 18.6138 4.27771 19.4735 7.45682C19.8136 8.7148 20 9.99214 20 11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M8.99805 7.99805H9.00195V8.00195H8.99805V7.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M11.998 5.99805H12.002V6.00195H11.998V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M14.998 7.99805H15.002V8.00195H14.998V7.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 11H21V12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12V11Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Rice = Vue.extend<IconProps>({
  name: 'RiceIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'rice',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Rice;
